import { instanceOfReference, instanceOfNumberRange } from "@perxis-auto/shared";
import { instanceOfFilterPrimitive } from "../../filterValues/lib/instanceOf/instanceOfFilterPrimitive.js";
import { instanceOfFilterRange } from "../../filterValues/lib/instanceOf/instanceOfFilterRange.js";
import { ConstructorWidgetEnum } from "../../../shared/types/constructor/widget.js";
const takeExistingFilterValue = (filterValues, availableFilterValues, filterGridItem) => {
  if (!availableFilterValues || !filterValues.length || !filterGridItem) {
    return;
  }
  if (Array.isArray(availableFilterValues) && availableFilterValues.length && instanceOfReference(availableFilterValues[0])) {
    const availableFilterItemValues = [...availableFilterValues];
    const existingFilterItemValues = [];
    availableFilterItemValues.forEach((filterItemValue) => {
      const value = filterValues.find((value2) => value2 === filterItemValue.id || value2 === filterItemValue.slug);
      if (typeof value !== "undefined") {
        existingFilterItemValues.push(filterItemValue.id);
      }
    });
    if (existingFilterItemValues.length) {
      switch (filterGridItem.type) {
        case ConstructorWidgetEnum.FilterSelect:
        case ConstructorWidgetEnum.FilterSlider: {
          return existingFilterItemValues[existingFilterItemValues.length - 1];
        }
        case ConstructorWidgetEnum.FilterMultipleSelect:
        case ConstructorWidgetEnum.FilterLocation:
        case ConstructorWidgetEnum.FilterCheckboxGroup:
        case ConstructorWidgetEnum.FilterModels:
        case ConstructorWidgetEnum.FilterColorPicker:
        case ConstructorWidgetEnum.FilterDuoColorPicker: {
          return Array.from(/* @__PURE__ */ new Set([...existingFilterItemValues]));
        }
        default: {
          return;
        }
      }
    }
  }
  if (Array.isArray(availableFilterValues) && availableFilterValues.length && instanceOfFilterPrimitive(availableFilterValues[0])) {
    const availableFilterPrimitiveValues = [...availableFilterValues];
    const existingFilterPrimitiveValues = [];
    availableFilterPrimitiveValues.forEach((filterPrimitiveValue) => {
      if (filterValues.some((value) => value == filterPrimitiveValue.value)) {
        existingFilterPrimitiveValues.push(filterPrimitiveValue.value);
      }
    });
    if (existingFilterPrimitiveValues.length) {
      switch (filterGridItem.type) {
        case ConstructorWidgetEnum.FilterSelect:
        case ConstructorWidgetEnum.FilterSlider: {
          return existingFilterPrimitiveValues[existingFilterPrimitiveValues.length - 1];
        }
        case ConstructorWidgetEnum.FilterMultipleSelect:
        case ConstructorWidgetEnum.FilterLocation:
        case ConstructorWidgetEnum.FilterCheckboxGroup:
        case ConstructorWidgetEnum.FilterModels:
        case ConstructorWidgetEnum.FilterColorPicker:
        case ConstructorWidgetEnum.FilterDuoColorPicker: {
          return Array.from(/* @__PURE__ */ new Set([...existingFilterPrimitiveValues]));
        }
        default: {
          return;
        }
      }
    }
  }
  if (instanceOfFilterRange(availableFilterValues)) {
    const filterRangeValues = filterValues.map((value) => Number(value)).sort((a, b) => a - b);
    switch (filterGridItem.type) {
      case ConstructorWidgetEnum.FilterSlider: {
        return filterRangeValues[0];
      }
      case ConstructorWidgetEnum.FilterRangeSlider: {
        if (!instanceOfNumberRange(filterRangeValues)) {
          return;
        }
        return [
          Math.max(availableFilterValues.min, filterRangeValues[0]),
          Math.min(availableFilterValues.max, filterRangeValues[1])
        ];
      }
      default: {
        return;
      }
    }
  }
};
export {
  takeExistingFilterValue
};
